module.exports = __webpack_public_path__ + "static/media/banner-ba.e084f100.jpg";